import React from 'react';
import { node } from 'prop-types';
import { Heading } from './styles';

const Title = ({ children, ...props }) => (
  <Heading data-page-title {...props}>
    {children}
  </Heading>
);

Title.propTypes = {
  children: node.isRequired,
};

export default Title;
